import { AppState } from 'modules/rootReducer';

export const progressSelector = (state: AppState): number | null => {
  return state.progress.progress;
};
